import React from "react";
import {CommentProps} from "./types";
import {useStyles} from "./styles";
import Carousel from "react-multi-carousel";
import {CommentCard} from "../comments-card/comments-card";

export const Comments = (props: {data: CommentProps} ) => {
    const classes = useStyles();
    const { title, comments } = props.data;

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            partialVisibilityGutter: 40
        },
        tablet: {
            breakpoint: { max: 1200, min: 600 },
            items: 1,
            partialVisibilityGutter: 30
        },
        mobile: {
            breakpoint: { max: 600, min: 0 },
            items: 1,
            partialVisibilityGutter: 30
        },
    };

    const CustomDots = ({onClick, index, active} : {onClick?: any, index?: any, active?: any}) => {
        return (
            <button
                className={"carousel-dot-item " + (active ? "active" : "")}
                onClick={() => onClick()}
            >
                {props.data.comments[index].img}
            </button>
        );
    };

    let settings = {
        additionalTransfrom: 0,
        centerMode: false,
        swipeable: true,
        draggable: true,
        showDots: true,
        customDot: <CustomDots />,
        arrows: false,
        responsive: responsive,
        infinite: false,
        autoPlay: false,
        autoPlaySpeed: 2000,
        showThumbs: false,
        slidesToSlide: 1,
    };

    return (
        <div className={"commentsCarousel " + classes.commentsContainer}>
            <div className={"h1 " + classes.commentsTitle}>{title}</div>
            <div className={classes.commentsCarousel}>
                <Carousel
                    {...settings}
                    beforeChange={(nextSlide, { currentSlide}) => {
                    const carouselTrack = document.querySelector(".commentsCarousel .react-multi-carousel-track");
                    const carouselItem = document.querySelector(".commentsCarousel .react-multi-carousel-item[data-index='"+nextSlide+"'] > div");
                    if (carouselTrack && carouselItem) {
                        const prevTrackStyles = carouselTrack.getAttribute("style");
                        carouselTrack.setAttribute("style", prevTrackStyles + " height: "+carouselItem.clientHeight+"px;")
                    }
                }}>
                    {comments && comments.map((comment, idx) => (
                        <div key={idx}>
                            <CommentCard {...comment} />
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};
